import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { createPortal } from 'react-dom'

import whenVisibleArea from 'ally.js/when/visible-area'
import firstTabbable from 'ally.js/query/first-tabbable'
import maintainDisabled from 'ally.js/maintain/disabled'
import maintainHidden from 'ally.js/maintain/hidden'
import maintainTabFocus from 'ally.js/maintain/tab-focus'
import whenKey from 'ally.js/when/key'

import ModalWrapper from './ModalWrapper'
import ModalPane from './ModalPane'

import s from './Modal.module.css'

class Modal extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    handleClose: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.mounted = false
    this.paneRef = React.createRef()
    this.portalElement = document.createElement('div')
  }

  componentDidMount() {
    this.mounted = true
    this.prevFocusElement = document.activeElement

    document.body.appendChild(this.portalElement)
    document.body.classList.add(s.withModal)

    const dialog = this.paneRef.current

    // ally.js -> https://allyjs.io/tutorials/accessible-dialog.html
    whenVisibleArea({
      context: dialog,
      callback(context) {
        const focusElement = firstTabbable({
          context,
          defaultToContext: true
        })
        focusElement.focus()
      }
    })
    this.disabledHandle = maintainDisabled({ filter: dialog })
    this.hiddenHandle = maintainHidden({ filter: dialog })
    this.tabHandle = maintainTabFocus({ context: dialog })
    this.keyHandle = whenKey({
      escape: this.close
    })

    document.body.addEventListener('mouseup', this.handleOuterClick)
    document.body.addEventListener('touchend', this.handleOuterClick)
  }

  componentWillUnmount() {
    if (this.mounted) {
      this.mounted = false
      document.body.removeChild(this.portalElement)
      document.body.classList.remove(s.withModal)

      // disable ally.js handlers
      this.disabledHandle.disengage()
      this.hiddenHandle.disengage()
      this.tabHandle.disengage()
      this.keyHandle.disengage()

      document.body.removeEventListener('mouseup', this.handleOuterClick)
      document.body.removeEventListener('touchend', this.handleOuterClick)

      if (this.prevFocusElement) {
        this.prevFocusElement.focus()
      }
    }
  }

  handleOuterClick = event => {
    const isOuter = (
      event.target !== this.paneRef.current &&
      !this.paneRef.current.contains(event.target)
    )

    if (isOuter) {
      this.close()
    }
  }

  close = () => {
    if (this.props.handleClose) {
      this.props.handleClose()
    }
  }

  render() {
    return createPortal(
      <ModalWrapper>
        <ModalPane ref={this.paneRef} shadow='high' tabIndex={0}>
          {this.props.children}
        </ModalPane>
      </ModalWrapper>,
      this.portalElement
    )
  }
}

export default Modal
